import { callApi } from 'util/call-api';
import { runInDevelopment } from 'util/utils';

import { ADMIN_UPDATE_USER } from 'constants/apiConstant';

export class UserService {
  static async updateUserProfile(request = {}) {
    return callApi({ ...ADMIN_UPDATE_USER, request });
  }
}

void runInDevelopment?.(() => void (window.__UserService = UserService));
